import type React from 'react'
import styled from 'styled-components'

import type { TooltipProps } from './Tooltips'
import { Tooltip } from './Tooltips'

export const IconContainerSpan = styled.span`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.common.darkPurple};

  & > svg {
    transform: translate(0, 2px);
  }
`

interface IconTooltipProps extends Omit<TooltipProps, 'children' | 'title'> {
  icon: NonNullable<React.ReactNode>
  title: NonNullable<React.ReactNode>
}

export function IconTooltip({ icon, title, ...rest }: IconTooltipProps) {
  return (
    <Tooltip title={title} {...rest}>
      <IconContainerSpan>{icon}</IconContainerSpan>
    </Tooltip>
  )
}
